import React from 'react';
import { WaBroadcastSettings } from '../../waBroadcast';
import { PageHeader, PageLayout } from '../../components/layout';

/**
 * WhatsApp Broadcast as its own page, reached from the sidebar (Alex,
 * 2026-10-16) rather than a Settings tab. Built from Fontaine primitives only,
 * so no legacy settings cascade.
 */
export function WaBroadcastPage() {
  return (
    <PageLayout className="rc-settings-modern">
      <PageHeader
        title="WhatsApp Broadcast"
        description="Post your store's items to your WhatsApp groups, one message at a time"
        showBackButton={false}
      />
      <WaBroadcastSettings />
    </PageLayout>
  );
}
